import React, { Component, Fragment } from "react";
import { translate } from "../Services/translation";
import CartSummaryRow from "./Cart/Cart.CartSummaryRow";
import PriceModelSelector from "./PriceModelSelector";
import BuyButtonContainer from "../Containers/BuyButton.Container";

class ConfiguratorSummary extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { product, carPriceLists, setCarPriceList } = this.props;

    const carParts = [
      "color",
      "drive",
      "transmission",
      "package",
      "engine",
      "tyre",
    ];

    const isInStock = product && product.isInStock;
    const articleNumber = isInStock ? product.id : null;
    const buttonLabel = isInStock
      ? translate("cart.addtocart")
      : translate("cart.outofstock");
    const buttonCss = isInStock
      ? "button buy-button configurator-summary__buy-button"
      : "button buy-button configurator-summary__buy-button disabled";
    const buyButton = {
      label: buttonLabel,
      articleNumber,
      cssClass: buttonCss,
    };

    let productTotalPrice = null;
    let currency = null;
    let modelRow = null;
    if (product && product.price && product.price.price) {
      productTotalPrice = product.price.price.priceWithVat;
    } else {
      productTotalPrice = "-";
    }
    if (product) {
      currency = product.currency.symbol;
      modelRow = product.model;
    }
    const selectedPriceListDisplayName = carPriceLists.find(x => x.isSelected === true).displayName;

    const shareScriptWebsiteString = "configurator.summary.sharescript";
    const shareScript =
      translate(shareScriptWebsiteString) == shareScriptWebsiteString
        ? null
        : translate(shareScriptWebsiteString);

    return (
      <div className="configurator-summary cart small-12 large-8">
        <div className="cart-header__header">
          <div className="cart-header__header-middle">
            <h1>{translate("checkout.cart.headertext")}</h1>
          </div>
        </div>
        <div className="small-12">
          <div className="cart-summary">
            <div className="cart-summary__row">
              <span className="cart-summary__row-column cart-summary__row-column--header">
                {translate("cart.financingmethodheader")}
              </span>
              <span className="cart-summary__row-column cart-summary__row-column--value">
                {selectedPriceListDisplayName}
              </span>
              <span className="cart-summary__row-column cart-summary__row-column--price-selector">
                <PriceModelSelector
                  includeHeader={true}
                  carPriceLists={carPriceLists}
                  setCarPriceList={setCarPriceList}
                />
              </span>
            </div>
            {product && modelRow && (
              <>
                <CartSummaryRow key={modelRow.fieldId} data={modelRow} />
              </>
            )}
            {product &&
              carParts.map((carPart) => {
                if (product[carPart]) {
                  return (
                    <CartSummaryRow
                      key={product[carPart].fieldId}
                      data={product[carPart]}
                    />
                  );
                } else {
                  return;
                }
              })}
            {product ? (
              <></>
            ) : (
              <div className="cart-summary__error empty-result-error">
                {translate("configurator.noconfiguratorresult")}
              </div>
            )}
          </div>
        </div>
        {shareScript && (
          <div className="configurator-summary__share" dangerouslySetInnerHTML={{__html: shareScript}} />
        )}
      </div>
    );
  }
}
export default ConfiguratorSummary;
